import copy from '../i18n/ns/workspace-errors.ts';
export function workspaceErrorCopy(locale?: string) {
  const l = (locale ?? 'en').toLowerCase().split('-')[0] as keyof typeof copy;
  return copy[l] ?? copy.en;
}
